import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricClicks extends MetricBase {
    constructor() {
        super({
            field: "metric_clicks",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.skyscanner.clicks.chartName"),
            serieLabel: i18n.t("metrics.skyscanner.clicks.serieLabel"),
            tooltip: i18n.t("metrics.skyscanner.clicks.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricClicks;
